export default "__VITE_ASSET__VWBzZtbG__"